import {  Repository } from "./repository";
const resource = "Store";
const StoreRepo = {
    getStoreInfo
};
function getStoreInfo(payLoad) {
    return Repository().get(`${resource}/getStoreFactoreInfo?${payLoad}`);
}

export default StoreRepo;